import { config } from '../config';

const INTERSTITIAL_LOG_PREFIX = '[Ads][Interstitial]';

const normalizeEnvironment = (value) => String(value || '').trim().toLowerCase();

export const shouldLogInterstitialDebug = () => normalizeEnvironment(config.ENVIRONMENT) !== 'production';

export const logInterstitialDebug = (details = {}) => {
  if (!shouldLogInterstitialDebug()) {
    return;
  }

  console.debug(INTERSTITIAL_LOG_PREFIX, details);
};

export const logInterstitialStage = (stage, details = {}) => {
  logInterstitialDebug({
    stage,
    ...details,
  });
};
